<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newCustomer()"
                aria-label="New customer">
            {{'New'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/open-bills" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">receipt</mat-icon>
                <span>{{'Open bills'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/users-online" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Users online'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/resources-in-use" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Resources online'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/carts" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">shopping_cart</mat-icon>
                <span>{{'Online Carts'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/active-vouchers" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">shopping_cart</mat-icon>
                <span>{{'Active vouchers'|translate}}</span>
            </a>
        </div>
<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple routerLink="/cards" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">credit_card</mat-icon>-->
<!--                <span>{{'Cards'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
